<template lang="html">
  <div class="try-audio" v-if="url">
    <!-- <img class="try-audio-image" :src="image" alt="try"/> -->
    <div class="try-audio-container">
      <div class="try-audio-main">
        <audio :src="url" ref="audio"></audio>
        <div class="try-audio-button"
          @click="handleClick">
          <img v-if="paused" src="../assets/images/audio-play.png" alt="">
          <img v-else src="../assets/images/audio-pause.png" alt="">
        </div>
        <div class="try-audio-content">
          <div class="try-audio-title">{{title}}</div>
          <div class="try-audio-icon">
            <img src="../assets/images/try-audio-icon.png" class="img-f" alt="">
          </div>
        </div>

        <div class="try-audio-control">
          <div class="try-audio-line">
            <div class="try-audio-line-current" :style="{ width: width }"></div>
          </div>
          <div class="try-audio-current">{{ currentTime | formatSeconds}}</div>
          <div class="try-audio-duration">{{ total | formatSeconds}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatSeconds from '../filters/format-seconds-2'

export default {
  name: 'TryAudio',

  props: ['title', 'url', 'length', 'image'],

  data () {
    return {
      paused: true,
      currentTime: 0,
      duration: 0,
      isEventBinded: false
    }
  },

  computed: {
    total () {
      return this.duration || this.length || 0
    },
    width () {
      if (!this.total || !this.currentTime) {
        return 0
      }
      return Math.round(this.currentTime / this.total * 100) + '%'
    },
    player () {
      return this.$refs.audio
    }
  },

  filters: {
    formatSeconds
  },

  methods: {
    handleClick () {
      if (!this.isEventBinded) {
        this.player.addEventListener('timeupdate', () => {
          this.currentTime = this.player.currentTime
          this.duration = this.player.duration
        })

        this.player.addEventListener('error', () => {
          this.player.load()
        })

        this.isEventBinded = true
      }

      if (this.paused) {
        this.player.play()
      } else {
        this.player.pause()
      }

      this.paused = !this.paused
    }
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.try-audio {
  &-main {
    height: use(180);
    border-radius: use(8);
    background-color: #F5F6F8;
    border: 1px solid #E6E6E6;
  }

  &-image {
    width: 100%;
  }

  &-container {
    padding: use(30);
  }

  audio {
    display: none;
  }
  &-button {
    float: left;
    @include square(170, 100%);
    @include center-box();
    img {
      @include square(90);
    }
  }
  &-content {
    float: left;
    width: use(480);
    margin-top: use(20);
    position: relative;
  }
  &-title {
    font-size: use(28);
    line-height: 1.5em;
    @include square(415, 3em);
    @include text-overflow(2);
  }
  &-icon {
    @include square(60, 30);
    @include absolute(5);
    right: 0;
  }
  &-control {
    float: left;
    margin-top: use(20);
    width: use(480);
    font-size: use(22);
    color: #999999;
  }
  &-line {
    @include square(100%, 1px);
    background-color: #ADADAD;
    position: relative;
    margin-bottom: use(16);
    &-current {
      @include absolute('tlh');
      background-color: #FF8900;
      @include scaleY(2);
    }
  }
  &-current {
    float: left;
  }
  &-duration {
    float: right;
  }
}
</style>
